import { render } from "./BreakdownOrigin.vue?vue&type=template&id=04c94fec&scoped=true"
import script from "./BreakdownOrigin.vue?vue&type=script&lang=js"
export * from "./BreakdownOrigin.vue?vue&type=script&lang=js"

import "./BreakdownOrigin.vue?vue&type=style&index=0&id=04c94fec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c94fec"]])

export default __exports__